import React from 'react';
import useExploreStore from '../../contexts/useExploreStore';

const NewQuestionButton = () => {
  const { setShowStarterPanel } = useExploreStore();

  const handleClick = () => {
    // Set the panel back to starter without altering the currentQuery
    setShowStarterPanel(true);
  };

  return (
    <button
      className="bg-blue-500 text-white px-4 py-2 rounded shadow-lg hover:bg-blue-600 focus:outline-none"
      onClick={handleClick}
      aria-label="Save and New Question"
    >
      New Question
    </button>
  );
};

export default NewQuestionButton;
